<template>
  <div class="content">
    <div @click="changePerson" v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;font-size: .3rem;">
        <el-col :span="8">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">当前就诊人：</div>
        </el-col>
        <el-col :span="13">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_patient_name}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="width:100%;height: 4rem;background-color: #fff;font-size: .3rem;" v-if="name&&zyh&&zyts&&$storage.get('patient')">
      <el-row>
        <el-col :span="10" style="height: 1rem;line-height: 1rem;margin-left: .3rem">姓名：{{name}}</el-col>
        <el-col :span="10" style="height: 1rem;line-height: 1rem;">就诊卡号：{{$storage.get('patient').clinic_num?$storage.get('patient').clinic_num:'000000'}}</el-col>
      </el-row>
      <div style="width: 90%;margin: 0 auto;background-color: #FAFAD2;height: 1.2rem;border-radius: .1rem">
        <el-row>
          <el-col :span="12" style="height: .6rem;line-height: .6rem;margin-left: .3rem">住院号：{{zyh}}</el-col>
          <el-col :span="10" style="height: .6rem;line-height: .6rem;">住院天数：{{zyts}}天</el-col>
        </el-row>
        <div style="height: .6rem;line-height: .5rem;margin-left: .3rem">入院日期：{{zydate}}</div>
      </div>
      <div style="width: 90%;margin: .3rem auto;background-color: #FAFAD2;height: 1.2rem;border-radius: .1rem">
        <el-row>
          <el-col :span="12" style="height: .6rem;line-height: .6rem;margin-left: .3rem">预交金总额：{{yjamount}}</el-col>
          <el-col :span="10" style="height: .6rem;line-height: .6rem;">总费用：{{amount}}</el-col>
        </el-row>
        <div style="height: .6rem;line-height: .5rem;margin-left: .3rem" :class="parseFloat(yjmoney)<0?'redC':''">预交金余额：{{yjmoney}}</div>
      </div>
    </div>
    <div v-if="name&&zyh&&zyts&&$storage.get('patient')">
      <Menu src="static/img/yujiaojinjiaona.png" text="预交金缴纳" style="background-color: white;margin-top: .1rem" to-url="/hospitalPay"></Menu>
      <Menu src="static/img/meiriqingdan.png" text="每日清单" style="background-color: white" to-url="/dailyListing"></Menu>
      <Menu src="static/img/zhuyuanfeiyong.png" text="费用清单" style="background-color: white" to-url="/expensesList"></Menu>
    </div>
    <div class="noCard" v-if="!name&&!zyh&&!zyts">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无住院信息</div>
    </div>
  </div>
</template>

<script>
  import Menu from '../common/Menu'
  import {getzyfeelist} from '../../api/index'
    export default {
      data(){
        return{
          name:'',
          zyh:'',
          zyts:'',
          zydate:'',
          yjamount:'',
          amount:'',
          yjmoney:'',
        }
      },
      components:{
        Menu
      },
      created() {
        //修改标题
        document.title = '住院信息'
        if(this.$storage.get('patient')){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getzyfeelist({
            name:this.$storage.get('patient').clinic_patient_name,
            cardnum:this.$storage.get('patient').clinic_num,
            healthcardno:this.$storage.get('patient').healthCardId,
            patientid:this.$storage.get('patient').patient_id,
          }).then(res=>{
            loading.close();
            if(res.Data.length>0){
              this.name = res.Data[0].姓名
              this.cardnum = res.Data[0].就诊卡号
              this.zyh = res.Data[0].住院号
              this.zyts = res.Data[0].住院天数
              this.zydate = res.Data[0].入院日期
              this.yjamount = res.Data[0].预交金总额
              this.amount = res.Data[0].总费用
              this.yjmoney = res.Data[0].预交金余额
            }
          })
        }
      },
      methods:{
        //换人
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
  .redC{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/hospitalInfo.vue